//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import React, { useEffect } from 'react';

import { useSmartInputContext } from '@components/molecules/smart-input/SmartInputContext';
import { getIsCursorInMention } from '@components/molecules/smart-input/mentions/mentionsUtils';

interface Props {
  children?: React.ReactNode;
}

/**
 * This component is rendered by a custom mention strategy when a `@` is typed.
 * It has the purpose of updating state so that the MentionsSuggestionsDropdown will be rendered.
 */
export const MentionsSuggestionsDropdownTrigger = ({ children }: Props) => {
  const smartInputContext = useSmartInputContext();

  /**
   * Only run the effect on mounting of the component so it does not reopen the dropdown
   * when it is closed from external methods
   */
  useEffect(() => {
    smartInputContext.mentions?.setIsDropdownOpen(true, true);

    return () => {
      // When the trigger is removed it may either be deleted or it will transition to a mention component
      // Only close the dropdown if the trigger is being removed
      const editorState = smartInputContext.editor.getEditorState();
      const shouldCloseDropdown = !getIsCursorInMention(
        editorState,
        smartInputContext,
      );

      if (shouldCloseDropdown) {
        smartInputContext.mentions?.setIsDropdownOpen(false, false);
      }
    };
  }, []);

  return <>{children}</>;
};
